<script>
export default {
  name: "DidoDownloadButtonDatafile",
};
</script>

<script setup>
import { computed } from "vue";
import api from "../../../api";
import DidoDownloadItemMillesime from "../items/Millesime.vue";

// define Props
const props = defineProps({
  apiUrl: { type: String, required: true },
  datafile: { type: Object, required: true },
});

// define computed datas
const buttonTooltip = computed(
  () =>
    `Télécharger un export (choix du format et du millésime) du fichier de données '${props.datafile.title}'`,
);
const millesimesOfDatafile = computed(() => {
  if (!props.datafile) return [];
  const { millesimes } = props.datafile;
  return millesimes
    .sort((m1, m2) => new Date(m1.millesime) - new Date(m2.millesime))
    .reverse()
    .map((millesime) => ({
      rid: props.datafile.rid,
      title: props.datafile.title,
      description: props.datafile.description,
      millesime: millesime.millesime,
      geoFields: millesime.geoFields || [],
      baseLink: api.urlDatafileBase(props.apiUrl, props.datafile.rid),
    }));
});
</script>

<template>
  <QBtnDropdown
    split
    color="secondary"
    no-caps
    dense
    size="md"
    unelevated
    :title="buttonTooltip"
    :content-class="['no-border-radius', 'no-box-shadow', 'border-secondary']"
    class="dido-download-datafile no-border-radius"
  >
    <template #label>
      <div class="fit row-start-center no-wrap">
        <QIcon name="mdi-archive" />
        <div class="q-ml-sm full-height column-all-start no-wrap">
          <div
            class="dido-download-datafile-button-label-text-main row-start-center no-wrap"
          >
            <span class="q-mr-sm">Télécharger un export</span>
          </div>
          <div
            class="dido-download-datafile-button-label-text-sub text-caption text-italic text-left"
          >
            Choisir un millésime et un format
          </div>
        </div>
      </div>
    </template>
    <div class="q-pa-sm text-italic">Choisir un fichier à télécharger</div>
    <QList separator>
      <QSeparator />
      <DidoDownloadItemMillesime
        v-for="(millesimeObject, index) in millesimesOfDatafile"
        :key="`millesime-${index}`"
        :api-url="props.apiUrl"
        :millesime-object="millesimeObject"
      />
    </QList>
  </QBtnDropdown>
</template>

<style lang="sass" scoped>
.dido-download-datafile
  min-height: 60px
  max-height: 60px
  .dido-download-datafile-button-label-text-main
    font-size: 0.75rem
  .dido-download-datafile-button-label-text-sub
    font-size: 0.6rem
    line-height: 0.8rem
    white-space: normal
    min-width: 128px
    max-width: 128px
</style>
